const convertSourcesToOptions = (sources) =>
  sources.map((source) => ({value: source, label: source}));

export default convertSourcesToOptions;
